export default "__VITE_ASSET__40d7bcc9__"